import { Box } from '@mui/material'
import EmptyStateBlock from './EmptyStateBlock'
import ThreadListRow from './ThreadListRow'
import { BoardsSectionPinnedList } from './BoardsSectionPinnedList.jsx'
import styles from './BoardsSection.module.scss'

export function BoardsSectionList({ showAll, boards, pinnedThreads, selectedThreadId, onBoardClick, onSelectThread, onThreadMenuAction, onRenameThread }) {
  if (showAll) {
    return (
      <Box className={styles.list}>
        {boards.map((board) => (
          <ThreadListRow key={board.id} title={board.name} onClick={() => onBoardClick?.(board)} />
        ))}
      </Box>
    )
  }

  if (pinnedThreads.length > 0) {
    return (
      <BoardsSectionPinnedList
        pinnedThreads={pinnedThreads}
        selectedThreadId={selectedThreadId}
        onSelectThread={onSelectThread}
        onThreadMenuAction={onThreadMenuAction}
        onRenameThread={onRenameThread}
      />
    )
  }

  return (
    <EmptyStateBlock
      title="No Boards here"
      description="Add your threads/Chambers to boards so you can find what your activities organized in one place & help you move faster."
      variant="boards"
    />
  )
}
